<template>
    <div class="result-report">
        <div class="result-title" v-if="mode === 'Mobile'">练习报告</div>
        <div class="result-score">
            <div class="circle-score">
                <svg viewBox="0 0 100 100">
                    <path
                        d="M 20 60 A 36 36 0 1 1 80 60"
                        stroke-linecap="round"
                        stroke-width="3"
                        stroke="#efefef"
                        fill="none"
                    />
                    <path
                        d="M 20 60 A 36 36 0 1 1 80 60"
                        stroke-linecap="round"
                        stroke-width="3"
                        :stroke="resultInfo.correctScale > 60 ? '#61c5a1' : '#eb6661'"
                        fill="none"
                        :stroke-dasharray="`${(156 * resultInfo.correctScale) / 100}, 156`"
                    />
                </svg>
                <div class="container">
                    <div class="paper-score">得分</div>
                    <div class="score">{{ resultInfo.totalScore }}</div>
                    <div class="paper-score">/{{ paperInfo.score }}</div>
                </div>
            </div>
            <div class="paper-title">{{ paperInfo.title }}</div>
            <div class="result-detail">
                <div>
                    <div class="result-num success-state">{{ resultInfo.correctNum }}</div>
                    <div>正确数</div>
                </div>
                <div>
                    <div class="result-num error-state">{{ resultInfo.errorNum }}</div>
                    <div>错误数</div>
                </div>
                <div>
                    <div class="result-num">{{ resultInfo.unCompleteNum }}</div>
                    <div>未作答</div>
                </div>
                <div>
                    <div class="result-num success-state">{{ resultInfo.correctScale }}%</div>
                    <div>正确率</div>
                </div>
            </div>
        </div>
        <div class="guide" v-if="mode === 'Mobile'">
            <img src="https://res.peki.vip/20220908/fe5c541db2d14d68b949dbd9b9219ade1.png" />
        </div>
    </div>
</template>
<script>
export default {
    props: ['mode'],
    computed: {
        config() {
            return this.$store.state.paperResult.config
        },
        paperInfo() {
            return this.$store.state.paperResult.paperInfo
        },
        userAnswerMap() {
            return this.$store.state.paperResult.userAnswerMap
        },
        resultInfo() {
            const list = Object.values(this.userAnswerMap)
            let totalScore = 0
            let correctNum = 0
            let errorNum = 0
            list.forEach((item) => {
                totalScore += item.score || 0
                if (item.state) {
                    correctNum += 1
                }
                if (!item.state && item.answer) {
                    errorNum += 1
                }
            })
            let unCompleteNum = list.length - correctNum - errorNum
            const correctScale = parseInt((correctNum / list.length) * 1000) / 10
            return { totalScore, correctNum, errorNum, unCompleteNum, correctScale }
        },
    },
}
</script>
<style lang="scss" scoped>
@import '@/scss/paper.scss';

.result-report {
    height: 100%;
    overflow-y: auto;
}

.result-title {
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #efefef;
}
.result-score {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 24px 20px;
    .circle-score {
        width: 200px;
        height: 140px;
        position: relative;
        .container {
            bottom: 0;
            left: 50%;
            width: 120px;
            height: 120px;
            transform: translateX(-50%);
            position: absolute;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-evenly;
            .score {
                font-size: 32px;
                font-weight: 700;
            }
            .paper-score {
                color: #999;
                font-size: 12px;
            }
        }
    }
    .paper-title {
        width: 100%;
        margin: 18px 0 12px;
        border-top: 1px solid #efefef;
        border-bottom: 1px solid #efefef;
        padding: 12px 0;
        font-size: 12px;
        color: #666;
        text-align: center;
    }

    .result-detail {
        display: flex;
        align-items: center;
        margin-top: 10px;
        > div {
            font-size: 12px;
            color: #999;
            padding: 0 18px;
        }
        .result-num {
            font-weight: 700;
            font-size: 18px;
            line-height: 42px;
            color: #999;
            text-align: center;
        }
        .success-state {
            color: $success-color;
        }
        .error-state {
            color: $error-color;
        }
    }
}
.guide {
    display: flex;
    justify-content: flex-end;
    margin: 70px 12px 32px 0;
    img {
        width: 80px;
        height: 80px;
    }
}
</style>
